export default (resultA, resultB) => window.Core.Search.isSearchResultEqual(resultA, resultB);
